<div class="trim-player-wrapper" #wrapper>
	<bb-aspect-ratio-picker  *ngIf="cropSelect" [(ngModel)]="activeCropset" valueProp="name" (ngModelChange)="initCropper(); cropsetChanged()"
		name="cropset"></bb-aspect-ratio-picker>

	<!-- (hidden) snapshot player must be higher in the DOM than the normal player, otherwise we get unsafe source errors.. -->
	<!-- This player is only used to take screenshots for the frame-strip (low Q video) -->
	<basic-player *ngIf="mediaclip && lowQAssetPath" #snapshotPlayer class="snapshot-media-player"
		[srcFile]="lowQAssetPath" [settings]="{preload: 'auto', crossorigin: 'anonymous'}"></basic-player>

	<div class="player-margin" [style.margin]="isVertical ? '0 80px' : '0'">
		<!-- Set width so player in container resizes to fit and h-centers, must have no black fill space for correct crop saves -->
		<div class="player-container" [style.width]="( heightPlayer * ( mediaclip ? ( mediaclip.width / mediaclip.height ) : ( image.width / image.height ) ) ) + 'px'">

			<!-- mediaclip -->
			<basic-player *ngIf="mediaclip && assetPath" #player [height]="heightPlayer" class="trim-media-player" [srcFile]="canPlaySource ? sourceAsset : assetPath" (onTimeUpdated)="onTimeChanged($event)" (durationchange)="onDurationChange($event)" [settings]="{preload: 'auto', crossorigin: 'anonymous'}" [mediatype]="mediaclip?.mediatype"></basic-player>
			<!-- image -->
			<img *ngIf="image?.src" [src]="image.srcPrefix + image.src" alt="">
			<img *ngIf="image?.data" [src]="image.data" alt="">
			
			<div [hidden]="!cropSelect" class="cropper-container" #cropperContainer [style.height]="heightPlayer + 'px'">
				<div *ngIf="cropSelect" class="cropper" #cropper
					bbDrag
					[bbDragContainer]="cropperContainer"
					(bbDragEnded)="onCropResizeEnd($event)"
					bbResize
					(bbResizeEnded)="onCropResizeEnd($event)"
					[bbResizeContainer]="cropperContainer"
					[bbResizeHandles]="resizeHandles"
					[bbResizeLockAspectRatio]="activeCropset !== 'default'"
					[bbResizeConstrainAspectRatio]="activeCropset !== 'default'" [bbResizeMinSize]="100">
					<!-- used for bbResize -->
					<bb-resize-handles [handleStyle]="'brackets'" #resizeHandles></bb-resize-handles>
				</div>
			</div>
		</div>
	</div>

	<!-- Frameselect for mediaclip -->
	<div *ngIf="mediaclip && !lowQAssetPath" class="no-assets message warning">
		{{ 'NO_TRIM_ASSETS' | translate }}
	</div>

	<div [hidden]="!mediaclip" class="trimmer select-{{select}}" [style.visibility]="lowQAssetPath ? 'visible' : 'hidden'"
		#draggerSingle (mousedown)="onTrimmerSingleMouseDown($event)" (mousemove)="onTrimmerSingleMouseMove($event)"
		(mouseup)="onTrimmerSingleMouseUp()">
		<div class="frame-strip" #frameStrip [style.opacity]="initialised ? '1' : '0.8'">
			<div class="img-wrapper" *ngFor="let thumbnail of frames">
				<img alt="" [attr.src]="thumbnail.data" />
			</div>
			<div class="img-wrapper" *ngFor="let t of frameTimes">
				<!-- placeholder -->
			</div>
		</div>

		<!-- Select: Single -->
		<div class="dragger single" [class.dragging]="dragging" [hidden]="select !== 'single'">
			<div class="current-time single" #draggerSingleBar
				[style.left.%]="dragging ? dragLeft : basicPlayer?.media?.currentTime / duration * 100"></div>
		</div>

		<!-- Select: Range -->
		<div *ngIf="select === 'range'" class="dragger">
			<div class="mask" [style.width.%]="sizeObj?.offset * 100"></div>
			<div class="mask2" [style.width.%]="100 - ((sizeObj?.offset + sizeObj?.zoomFactor) * 100)"></div>
			<div class="drag-visual" [style.left.%]="sizeObj?.offset * 100" [style.width.%]="sizeObj?.zoomFactor * 100">
				<div class="top-mask"></div>
				<div class="bottom-mask"></div>
				<div class="drag-inner">
					<div class="drag-handle"></div>
					<div class="drag-handle"></div>
				</div>
				<div class="corner-mask t-l">
					<div class="cirle-cut-out"></div>
				</div>
				<div class="corner-mask t-r">
					<div class="cirle-cut-out"></div>
				</div>
				<div class="corner-mask b-r">
					<div class="cirle-cut-out"></div>
				</div>
				<div class="corner-mask b-l">
					<div class="cirle-cut-out"></div>
				</div>
			</div>

			<bb-resizable-scrollbar [class.dragging-bar]="draggingBar" [subject]="resizeBarSubject"
				[hideBackground]="true" [barColor]="'rgba(255, 255, 255, 0.5)'" (dragstart)="onDragStartRange()"
				(dragging)="onDraggingRange()" (dragend)="onDragEndRange()"></bb-resizable-scrollbar>

			<div class="current-time" [style.left.%]="basicPlayer?.media?.currentTime / duration * 100"></div>

			<div class="time-display" *ngIf="fromTime || toTime" #timeDisplay>
				<span class="time from-time" [class.on-light]="fromLeft === 10" [style.left.%]="sizeObj.offset * 100"
					[style.margin-left.px]="fromLeft" [class.long-duration]="fromTime >= 3600">
					<bb-timecode-editor [(ngModel)]="fromTime" [min]="0" [max]="toTime - 1" [fps]="fps"
						class="time-tooltip" (change)="onTimecodeChange('from', fromTime)"></bb-timecode-editor>
				</span><br />
				<span class="time to-time" [class.on-light]="toLeft !== 0"
					[style.left.%]="(sizeObj.offset + sizeObj.zoomFactor) * 100" [style.margin-left.px]="toLeft"
					[class.long-duration]="toTime >= 3600">
					<bb-timecode-editor [(ngModel)]="toTime" [min]="fromTime + 1" [max]="duration" [fps]="fps"
						class="time-tooltip" (change)="onTimecodeChange('to', toTime)"></bb-timecode-editor>
				</span><br />
			</div>
		</div>
	</div>

	<div *ngIf="mediaclip" class="sub-text">
		<span class="help-text">
			Use the keyboard <i class="fa fa-arrow-left"></i> and <i class="fa fa-arrow-right"></i> keys to seek one
			frame.
		</span>
		<span *ngIf="select === 'range' && (fromTime || toTime)" class="new-duration">{{ 'NEW_DURATION' | translate }}:
			{{ (toTime - fromTime) | seconds:'withFrames' }}</span>
		<span *ngIf="select === 'single'" class="new-duration">{{ this.currentTime | seconds:'withFrames' }}</span>
	</div>
</div>
